import { TypedUseSelectorHook, useSelector } from 'react-redux';

import type { RootState } from 'actions/index';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
